export default {"src":"/_next/static/media/enhanced.b354e484.svg","height":18,"width":25};